import React from "react";
import { t } from "../i18n";
import { CheckIcon } from "./Icons";
import { CHAT_WALLPAPERS, buildChatWallpaperStyle, useWallpaperTheme } from "../utils/chatWallpapers";

// Выбор обоев переписки — плитками с миниатюрой: обои цветом текущей темы и
// пара сообщений поверх, чтобы было видно, как они лягут под переписку.
//
// Узоры в миниатюре мельче, чем в переписке: плитка маленькая, и в настоящем
// масштабе в неё попадало бы два-три штриха.
const PREVIEW_SCALE = 0.6;

const scaleSize = (size) => String(size || "")
  .split(",")
  .map((part) => part.trim().replace(/([\d.]+)px/g, (_, n) => `${(Number(n) * PREVIEW_SCALE).toFixed(1)}px`))
  .join(", ");

export default function WallpaperPicker({ value = "none", onChange, isPhoneView = false }) {
  const theme = useWallpaperTheme();
  return (
    <div className={`wallpaper-picker${isPhoneView ? " is-phone" : ""}`} role="radiogroup" aria-label={t("Обои переписки")}>
      {CHAT_WALLPAPERS.map((item) => {
        const style = buildChatWallpaperStyle(item.id, { rgb: theme.rgb, light: theme.light, fade: "var(--wp-preview-bg)" });
        const active = value === item.id;
        return (
          <button
            key={item.id}
            type="button"
            role="radio"
            aria-checked={active}
            className={`wallpaper-picker-card${active ? " is-active" : ""}`}
            onClick={() => onChange && onChange(item.id)}
          >
            <span
              className="wallpaper-picker-preview"
              style={style ? { backgroundImage: style.backgroundImage, backgroundSize: scaleSize(style.backgroundSize) } : undefined}
            >
              <i className="wallpaper-picker-bubble is-in" />
              <i className="wallpaper-picker-bubble is-out" />
              <i className="wallpaper-picker-bubble is-in is-short" />
              {active && (
                <span className="wallpaper-picker-check"><CheckIcon size={12} color="#fff" /></span>
              )}
            </span>
            <span className="wallpaper-picker-name">{t(item.label)}</span>
          </button>
        );
      })}
    </div>
  );
}
